import groq from 'groq'

export const frameBuilderImageFragment = groq`
  ...,
  asset->,
`
